import { keys } from "@/lib/i18n/portal";
import type { StoreAdminStatsResponse } from "@/lib/api/types";

type Translator = (key: string) => string;

type Props = {
  stats: StoreAdminStatsResponse;
  t: Translator;
};

type StatItemProps = {
  label: string;
  value: number;
};

function StatItem({ label, value }: StatItemProps) {
  return (
    <div className="rounded-lg border border-[color:var(--border-light)] bg-[color:var(--surface)] px-3 py-2">
      <div className="text-[13px] text-[color:var(--text-muted)]">{label}</div>
      <div className="mt-1 text-lg font-semibold text-[color:var(--text-primary)]">
        {value}
      </div>
    </div>
  );
}

export function StoreStatsCard({ stats, t }: Props) {
  return (
    <section className="rounded-xl border border-[color:var(--border-light)] bg-[color:var(--surface)] px-4 py-3 text-sm sm:py-2.5">
      <div className="text-xs font-semibold text-[color:var(--text-secondary)]">
        {t(keys.admin.storeStatsTitle)}
      </div>

      <div className="mt-3 grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
        <StatItem
          label={t(keys.admin.storeStatsOrdersTotal)}
          value={stats.orders.total}
        />
        <StatItem
          label={t(keys.admin.storeStatsOrdersPending)}
          value={stats.orders.pending}
        />
        <StatItem
          label={t(keys.admin.storeStatsOrdersDelivered)}
          value={stats.orders.delivered}
        />
        <StatItem
          label={t(keys.admin.storeStatsProductsCount)}
          value={stats.catalog.products}
        />
        <StatItem
          label={t(keys.admin.storeStatsCategoriesCount)}
          value={stats.catalog.categories}
        />
      </div>
    </section>
  );
}
